/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CioConditionViewerGroup from 'cio/components/cio-condition-viewer-group';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import { segmentViewComponent } from 'cio/utils/segment-view-component';

interface SegmentsRowConditionListArgs {
  conditions: (AttributeCondition | DeviceAttributeCondition)[] | null;
}

export default class SegmentsRowConditionList extends Component<SegmentsRowConditionListArgs> {
  get conditions() {
    return this.args.conditions ?? [];
  }

  segmentViewComponent(condition: AttributeCondition | DeviceAttributeCondition) {
    // avoid circular references
    if ((condition.uiType ?? condition.type) === 'group') {
      return CioConditionViewerGroup;
    }

    return segmentViewComponent([condition]);
  }
}
